export const MANDATORY_TAG = "#gccworshipplatform";

export const ensureMandatoryTag = (candidateTags) => {
  const normalized = [
    ...new Set((candidateTags || []).map((tag) => (tag || "").trim()).filter(Boolean)),
  ];
  if (!normalized.includes(MANDATORY_TAG)) {
    normalized.unshift(MANDATORY_TAG);
  }
  return normalized;
};
